import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthDataService } from '../services/auth-data.service';

@Injectable({
  providedIn: 'root',
})
export class ModulesGuard implements CanLoad {
  constructor(
    private authDataService: AuthDataService,
    private router: Router
  ) {}

  canLoad():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authDataService.getUserData() !== null) {
      return true;
    }
    this.authDataService.logout();
    return false;
  }
}
